
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Breadcrumb } from 'components';
import{addVisitLog, history} from 'libs';
import { Input, Card, DatePicker, Button, Select, Upload, message, Modal} from 'antd';
import Table from './Table';
import Form from './Form';
import store from './store';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { ReloadOutlined, VerticalAlignBottomOutlined, SearchOutlined, PlusOutlined, UploadOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import styles from './index.module.less';
import { useTranslation } from 'react-i18next';
import SearchForm, {SearchFormItem} from "../../../components/SearchForm";


export default observer(function () {
  const { t } = useTranslation();
  const [openImport, setOpenImport] = useState(false);

  const uploadProps = {
    onChange({ file, fileList }) {
      if (file.status !== 'uploading') {
        console.log(file, fileList);
      }
    },
  }
  useEffect(() => {
    store.page = 1;
    store.pageSize = localStorage.getItem('customerFixedAssetsPageSize') || 10;
    store.pageTotal = 0;
    store.deviceName = null;
    store.deviceNo = null;
    store.keywords = null;
    store.organizationName = null;
    store.customerAssetNo = null;
    store.deviceSerialNo = null;
    store.brand = null;
    store.factoryCode = null;
    store.address = null;
    store.isDestroy = null;
    store.updatedName = null;
    store.updateTime = null;
    store.fetchRecords();
  }, [])

  // 上传
  const uploadFile = (file)=> {
    let param = new FormData()
    param.append('file', file.file)
    addVisitLog({
      pageName: '导入客户固资',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: 'ImportCustomerFixedAssets',
      eventName: "导入客户固资",
    })
    store.onImport(param).then((res) => {
      file.status = 'done';
      setOpenImport(false);
      if (res.data?.code===999) {
        file.message = '上传成功';
        message.success('批量导入成功！');
        resetSearch();
      }
    }).catch(error=>{
      if (error.indexOf('不能为空')===-1) {
        setOpenImport(false);
        Modal.confirm({
          title: '客户固资批量导入失败，是否下载导入失败文件？',
          icon: <ExclamationCircleOutlined />,
          onOk() {
            window.open("/javaApi/front/customerFixedAssets/downloadError?token="+localStorage.getItem('token'))
          },
          onCancel() {
          },
        });
      }
    })
  }

  const handleImport = ()=>{
    setOpenImport(true)
  }

  const handleExport = ()=>{
    store.onExport();
  }
  const handleSearch = ()=>{
    store.page = 1;
    store.pageSize = localStorage.getItem('customerFixedAssetsPageSize') || 10;
    store.pageTotal = 0;
    store.fetchRecords('1')
  }
  const handleCreate = ()=>{
    store.showForm({})
  }
  const handleDownloadTemp = ()=>{
    window.open('/javaApi/front/customerFixedAssets/downloadTemplateFile?token='+localStorage.getItem('token'))
  }
  const resetSearch = ()=>{
    store.page = 1;
    store.pageSize = localStorage.getItem('customerFixedAssetsPageSize') || 10;
    store.pageTotal = 0;
    store.deviceName = null;
    store.brand = null;
    store.keywords = null;
    store.factoryCode = null;
    store.deviceSerialNo = null;
    store.projectNo = null;
    store.customerAssetNo = null;
    store.contactPerson = null;
    store.address = null;
    store.receivProjectNo = null;
    store.organizationName = null;
    store.serviceType = null;
    store.updatedName = null;
    store.updateTime = null;
    store.fetchRecords('1')
  }


  const { RangePicker } = DatePicker;
  const { Option } = Select;


  return (
    <React.Fragment>
        <div className={[styles.cart, 'rest-nav1'].join(" ")}>
          <div className={styles.listTitle}>
            <span className={styles.title} style={{paddingLeft:'15px'}}>{t('我的固资管理')}</span>
          </div>
          <SearchForm 
            isExport={true} 
            isExportDetail={false} 
            isCreate={true} 
            isImport={true} 
            fetching = {store.fetching}
            onCreate={handleCreate} 
            onFinish={handleSearch} 
            onReset={resetSearch} 
            onUploadFile = {uploadFile}
            onImport = {handleImport}
            onDownloadTemp = {handleDownloadTemp}
            onExport={handleExport}>
            <SearchFormItem span={24} title='关键字识别'>
              <Input autoComplete="off" className='keywordsInput' allowClear style={{ width: '340px'}} value={store.keywords} onPressEnter={()=>handleSearch()} onChange={e => store.keywords = e.target.value}
                placeholder="请输入设备名称、货号、序列号模糊搜索" />
            </SearchFormItem>
            <SearchFormItem span={8} title='设备名称'>
              <Input autoComplete="off" allowClear value={store.deviceName} onChange={e => store.deviceName = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='品牌'>
              <Input autoComplete="off" allowClear value={store.brand} onChange={e => store.brand = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='货号'>
              <Input autoComplete="off" allowClear value={store.factoryCode} onChange={e => store.factoryCode = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='序列号'>
              <Input autoComplete="off" allowClear value={store.deviceSerialNo} onChange={e => store.deviceSerialNo = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='项目编号'>
              <Input autoComplete="off" allowClear value={store.projectNo} onChange={e => store.projectNo = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='客户固资编号'>
              <Input autoComplete="off" allowClear value={store.customerAssetNo} onChange={e => store.customerAssetNo = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='目前对接人'>
              <Input autoComplete="off" allowClear value={store.contactPerson} onChange={e => store.contactPerson = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='存放地点'>
              <Input autoComplete="off" allowClear value={store.address} onChange={e => store.address = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='接收项目编号'>
              <Input autoComplete="off" allowClear value={store.receivProjectNo} onChange={e => store.receivProjectNo = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='客户名称'>
              <Input autoComplete="off" allowClear value={store.organizationName} onChange={e => store.organizationName = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='最后操作人'>
              <Input autoComplete="off" allowClear value={store.updatedName} onChange={e => store.updatedName = e.target.value}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} title='最后操作时间'>
            <RangePicker allowClear value={store.updateTime} locale={locale} onChange={e => store.updateTime = e}/>
            </SearchFormItem>
          </SearchForm>
        </div>
        <div className="mainBox">
          <Table/>
        </div>
      {store.formVisible && <Form/>}
      <Modal
        title="导入客户固资"
        open={openImport}
        onOk={()=>setOpenImport(false)}
        onCancel={()=>setOpenImport(false)}
        footer={[
          <Button key="关闭" onClick={()=>setOpenImport(false)}>
            关闭
          </Button>
        ]}
      >
        <p><span className={styles.modal_label}>下载导入模板：</span><Button type='link' onClick={handleDownloadTemp}>客户固资批量导入模板</Button></p>
        <p>
          <span className={styles.modal_label}>文件上传：</span> 
          <Upload
              action=""
              customRequest={uploadFile}
              showUploadList={false}>
                  <Button 
                  style={{color:'#F1B10D',border:'1px solid #F1B10D',background:'rgba(241,177,13,0.1)' }}
                  >上传</Button>
                </Upload> </p>
      </Modal>
    </React.Fragment>
  )
})